var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5833 0H1.41667C0.635701 0 0 0.631865 0 1.40888V22.5421C0 23.3192 0.635701 23.951 1.41667 23.951H12.75V28.5904C12.75 29.1621 13.0931 29.6732 13.6243 29.892C13.8007 29.9646 13.9854 30 14.168 30C14.5361 30 14.8964 29.8569 15.1683 29.5866L20.835 23.951H32.5833C33.3643 23.951 34 23.3192 34 22.5421V1.40888C34 0.631865 33.3643 0 32.5833 0ZM32.5833 22.5421H20.835C20.4621 22.5421 20.0969 22.6924 19.8333 22.9549L14.1667 28.5904V23.951C14.1667 23.174 13.531 22.5421 12.75 22.5421H1.41667V1.40888H32.5833V22.5421Z",
    fill: "#F79C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66927 6.33955H28.3359C28.7275 6.33955 29.0443 6.02413 29.0443 5.63511C29.0443 5.24608 28.7275 4.93066 28.3359 4.93066H5.66927C5.27775 4.93066 4.96094 5.24608 4.96094 5.63511C4.96094 6.02413 5.27775 6.33955 5.66927 6.33955Z",
    fill: "#F79C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66927 10.5671H28.3359C28.7275 10.5671 29.0443 10.2517 29.0443 9.86264C29.0443 9.47362 28.7275 9.1582 28.3359 9.1582H5.66927C5.27775 9.1582 4.96094 9.47362 4.96094 9.86264C4.96094 10.2517 5.27775 10.5671 5.66927 10.5671Z",
    fill: "#F79C00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66927 14.7936H28.3359C28.7275 14.7936 29.0443 14.4782 29.0443 14.0892C29.0443 13.7002 28.7275 13.3848 28.3359 13.3848H5.66927C5.27775 13.3848 4.96094 13.7002 4.96094 14.0892C4.96094 14.4782 5.27775 14.7936 5.66927 14.7936Z",
    fill: "#F79C00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66927 19.0202H28.3359C28.7275 19.0202 29.0443 18.7048 29.0443 18.3158C29.0443 17.9267 28.7275 17.6113 28.3359 17.6113H5.66927C5.27775 17.6113 4.96094 17.9267 4.96094 18.3158C4.96094 18.7048 5.27775 19.0202 5.66927 19.0202Z",
    fill: "#F79C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.329817ec6e2127e8add128affb7a37c8.svg";
export { ForwardRef as ReactComponent };